module.exports = __webpack_public_path__ + "static/media/SHRIRAMFIN_F1.b08a9f88.txt";